/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ speakers: NonNullable<unknown>, recipients: NonNullable<unknown> }} Ccsl_Export_Speaker_To_RecipientInputs */

const en_ccsl_export_speaker_to_recipient = /** @type {(inputs: Ccsl_Export_Speaker_To_RecipientInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.speakers} TO: ${i?.recipients}`)
};

const fr_ccsl_export_speaker_to_recipient = /** @type {(inputs: Ccsl_Export_Speaker_To_RecipientInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.speakers} TO: ${i?.recipients}`)
};

const de_ccsl_export_speaker_to_recipient = /** @type {(inputs: Ccsl_Export_Speaker_To_RecipientInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.speakers} bis: ${i?.recipients}`)
};

const it_ccsl_export_speaker_to_recipient = /** @type {(inputs: Ccsl_Export_Speaker_To_RecipientInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.speakers} A: ${i?.recipients}`)
};

const ru_ccsl_export_speaker_to_recipient = /** @type {(inputs: Ccsl_Export_Speaker_To_RecipientInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.speakers} К: ${i?.recipients}`)
};

const es_ccsl_export_speaker_to_recipient = /** @type {(inputs: Ccsl_Export_Speaker_To_RecipientInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.speakers} A: ${i?.recipients}`)
};

const zh_cn2_ccsl_export_speaker_to_recipient = /** @type {(inputs: Ccsl_Export_Speaker_To_RecipientInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.speakers} 至：${i?.recipients}`)
};

const ja_ccsl_export_speaker_to_recipient = /** @type {(inputs: Ccsl_Export_Speaker_To_RecipientInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.speakers} 宛先: ${i?.recipients}`)
};

const hi_ccsl_export_speaker_to_recipient = /** @type {(inputs: Ccsl_Export_Speaker_To_RecipientInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.speakers} से: ${i?.recipients}`)
};

const pt_pt2_ccsl_export_speaker_to_recipient = /** @type {(inputs: Ccsl_Export_Speaker_To_RecipientInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.speakers} PARA: ${i?.recipients}`)
};

/**
* | output |
* | --- |
* | "{speakers} TO: {recipients}" |
*
* @param {Ccsl_Export_Speaker_To_RecipientInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_speaker_to_recipient = /** @type {((inputs: Ccsl_Export_Speaker_To_RecipientInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Speaker_To_RecipientInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_speaker_to_recipient(inputs)
	if (locale === "de") return de_ccsl_export_speaker_to_recipient(inputs)
	if (locale === "it") return it_ccsl_export_speaker_to_recipient(inputs)
	if (locale === "ru") return ru_ccsl_export_speaker_to_recipient(inputs)
	if (locale === "es") return es_ccsl_export_speaker_to_recipient(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_speaker_to_recipient(inputs)
	if (locale === "ja") return ja_ccsl_export_speaker_to_recipient(inputs)
	if (locale === "hi") return hi_ccsl_export_speaker_to_recipient(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_speaker_to_recipient(inputs)
	return en_ccsl_export_speaker_to_recipient(inputs)
});